/* configurator.js — "Visual Shopper" engine for the SydneyTaps theme.
 * Reads a per-product JSON config (embedded from custom.configurator metafield, or
 * the bundled demo asset), renders the steps, runs the declarative exclusion-rule
 * engine, computes a live price, and on Add-to-cart posts a bundle to /cart/add.js
 * (base variant + add-on variants + line-item properties). Sliced from the design
 * prototype's renderConfigurator. Styling: proto.css (.cfg*). */
(function () {
  'use strict';
  var root = document.querySelector('[data-configurator]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var MONEY = function (n) { return '$' + Math.round(n || 0).toLocaleString('en-AU'); };
  // an option row whose product is call-for-price (custom.availability) carries
  // call_for_price:true in the config the app compiles; the row prints the
  // label instead of a number (its price is null, so the total is unaffected).
  var OPT_PRICE = function (x) { return x && x.call_for_price ? 'Call for price' : MONEY(x.price); };
  var I = {
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7zM7.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4-3.4 7.5-8 9-4.6-1.5-8-5-8-9V6z"/></svg>',
    swatch: '<svg viewBox="0 0 24 24"><circle cx="9" cy="9" r="5"/><path d="M13 9h6M13 13h6M13 17h6"/></svg>'
  };

  function fail(e) { root.innerHTML = '<div class="cfg__loading">Configurator unavailable.</div>'; if (e && window.console) console.error('[configurator]', e); }

  var embedded = root.querySelector('[data-configurator-data]');
  if (embedded) { try { init(JSON.parse(embedded.textContent)); } catch (e) { fail(e); } }
  else if (root.dataset.demoSrc) { fetch(root.dataset.demoSrc).then(function (r) { return r.json(); }).then(init).catch(fail); }
  else fail();

  function init(C) {
    if (!C || !C.steps || !C.steps.length) return fail('empty config');
    var hero = root.dataset.hero || '';
    var firstSwatch = (C.steps.find(function (s) { return s.type === 'swatch' && s.options[0] && s.options[0].img; }) || {});
    var vimg = hero || (firstSwatch.options && firstSwatch.options[0] && firstSwatch.options[0].img) || '';
    // st[stepId]: option index for single-choice steps (null = unset),
    // a Set of option indexes for each addon-check step. Step ids come from
    // the seeded config (slugified titles) — never hardcode them here.
    var st = {};
    C.steps.forEach(function (s) {
      if (s.type === 'variant') st[s.id] = 0;
      else if (s.type === 'addon-radio' || s.type === 'addon-select') st[s.id] = 0;
      else if (s.type === 'addon-check') st[s.id] = new Set();
      else st[s.id] = null;
    });
    var opt = function (id) { return C.steps.find(function (s) { return s.id === id; }); };

    var stepBody = function (s) {
      var o = s.options;
      if (s.type === 'variant') return '<div class="cfg-tiles cfg-tiles--card">' + o.map(function (x, i) { return '<button class="cfg-tile cfg-tile--card" data-cfg="' + s.id + '" data-i="' + i + '" title="' + esc(x.name) + '"><span class="cfg-tile__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:11px;height:11px;display:block"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span><span class="cfg-tile__img" style="background-image:url(\'' + (x.img || vimg) + '\')"></span><span class="cfg-tile__lab">' + esc(x.name) + '</span><span class="cfg-tile__price">' + OPT_PRICE(x) + '</span></button>'; }).join('') + '</div>';
      if (s.type === 'swatch') return '<div class="cfg-tiles cfg-tiles--sw">' + o.map(function (x, i) { return '<button class="cfg-tile" data-cfg="' + s.id + '" data-i="' + i + '" title="' + esc(x.name) + '"><span class="cfg-tile__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:11px;height:11px;display:block"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span><span class="cfg-tile__img" style="' + (x.img ? "background-image:url('" + x.img + "')" : 'background:' + (x.swatch || '#e9e7e2')) + '"></span><span class="cfg-tile__lab">' + esc(x.name) + '</span></button>'; }).join('') + '</div>';
      if (s.type === 'addon-radio') return '<div class="cfg-chips">' + o.map(function (x, i) { return '<button class="cfg-chip' + (i === 0 ? ' is-on' : '') + '" data-cfg="' + s.id + '" data-i="' + i + '"><span>' + esc(x.name) + '</span>' + (x.call_for_price ? '<b>Call for price</b>' : x.price ? '<b>+' + MONEY(x.price) + '</b>' : '<b class="cfg-incl">Included</b>') + '</button>'; }).join('') + '</div>';
      if (s.type === 'radio') return '<div class="cfg-chips">' + o.map(function (x, i) { return '<button class="cfg-chip cfg-chip--wide" data-cfg="' + s.id + '" data-i="' + i + '">' + esc(x.name) + '</button>'; }).join('') + '</div>';
      if (s.type === 'select') return '<select class="cfg-select" data-cfgsel="' + s.id + '"><option value="">Select ' + esc(s.label.toLowerCase()) + '…</option>' + o.map(function (x, i) { return '<option value="' + i + '">' + esc(x.name) + (x.price ? ' (+' + MONEY(x.price) + ')' : '') + '</option>'; }).join('') + '</select>';
      if (s.type === 'addon-select') return '<select class="cfg-select" data-cfgsel="' + s.id + '">' + o.map(function (x, i) { return '<option value="' + i + '">' + esc(x.name) + (x.price ? ' — +' + MONEY(x.price) : '') + '</option>'; }).join('') + '</select>';
      if (s.type === 'addon-check') return '<div class="cfg-checks">' + o.map(function (x, i) { return '<label class="cfg-check"><input type="checkbox" data-cfgchk="' + s.id + '" data-i="' + i + '"><span>' + esc(x.name) + '</span><b>+' + MONEY(x.price) + '</b></label>'; }).join('') + '</div>';
      return '';
    };

    var tabsHtml = (C.tabs || []).map(function (t, i) {
      var body = t.body === '__downloads__'
        ? '<div class="cfg-dl">' + ['Specification sheet (PDF)', 'Installation guide (PDF)', 'WELS & Watermark certificate', 'CAD / Revit files'].map(function (d) { return '<a href="#">↓ ' + d + '</a>'; }).join('') + '</div>'
        : esc(t.body);
      return '<div class="acc__item' + (i === 0 ? ' is-open' : '') + '"><button class="acc__head" type="button">' + esc(t.t) + ' <span class="chev">+</span></button><div class="acc__body"><div class="acc__body-inner">' + body + '</div></div></div>';
    }).join('');

    root.innerHTML =
      '<div class="cfg">' +
        // breadcrumb now server-rendered by snippets/breadcrumbs.liquid (crawler-visible)
        '<div class="cfg__grid">' +
          '<div class="cfg__main">' +
            '<div class="cfg__intro">' +
              '<span class="pdp__vendor">' + esc(C.vendor || '') + '</span>' +
              '<h1>' + esc(C.title) + '</h1>' +
              '<p class="cfg__tag">' + esc(C.tagline || '') + '</p>' +
              // Rating: NEVER authored here. Until 2026-09-14 this line carried a
              // literal 4.8 / 212 reviews with a hardcoded --pct:96% — fixture
              // numbers painted onto a live product on a store with zero reviews
              // (Luke, 2026-09-14). PR #222 removed that half-built review path
              // from the Liquid surfaces but could not see this one, because it
              // is built by a JS string. The real row is server-rendered by
              // sections/configurator.liquid through snippets/rating-summary ->
              // snippets/rating-data, the single gate on reviews.rating /
              // reviews.rating_count; absent metafields emit no template at all,
              // so nothing lands here.
              '<div class="cfg__badges"><span class="cfg__badge">' + I.spark + ' Made to order</span></div>' +
            '</div>' +
            '<div class="cfg__steps">' +
              C.steps.map(function (s) {
                return '<section class="cfg-step" id="cfgstep-' + s.id + '">' +
                  '<div class="cfg-step__head"><span class="cfg-step__n">' + s.n + '</span>' +
                  '<div class="cfg-step__t"><h4>' + esc(s.label) + (s.required ? ' <i title="Required">*</i>' : '') + '</h4><span class="cfg-step__sub">' + esc(s.sub || '') + '</span></div>' +
                  '<span class="cfg-step__chosen" data-chosen="' + s.id + '"></span></div>' +
                  stepBody(s) + '</section>';
              }).join('') +
            '</div>' +
          '</div>' +
          '<aside class="cfg__side">' +
            '<div class="cfg__sel">' +
              '<div class="cfg__sel-head">Your Selection</div>' +
              '<div class="cfg__media"><img src="' + esc(vimg) + '" alt="' + esc(C.title) + '" data-cfg-img></div>' +
              '<div class="cfg__sel-body">' +
                '<p class="cfg__sel-name" data-cfg-selname></p>' +
                '<div class="cfg__total"><div class="cfg__total-n"><s data-cfg-rrp></s> <strong data-cfg-total></strong></div><span class="cfg__gst">inc GST</span></div>' +
                // NEVER the `disabled` attribute here. 182f266 (PR #46) moved the
                // add gate off `disabled` on purpose — a disabled button swallows
                // the very click the point-of-failure pattern needs in order to
                // mark the unmet steps — but left the attribute baked into this
                // markup, and nothing has cleared it since, so the button was
                // dead for every shopper the moment the config validated.
                // update() owns the gate through .is-blocked + aria-disabled.
                '<button class="btn btn--block btn--lg is-blocked" data-cfg-add aria-disabled="true">Select required options</button>' +
                '<p class="cfg__hint" data-cfg-hint></p>' +
                '<ul class="cfg-sum" data-cfg-sum></ul>' +
                '<p class="cfg__lead">' + I.truck + ' ' + esc(C.leadTime || '') + '</p>' +
                '<div class="cfg__assure"><span>' + I.shield + ' 7-yr cabinet warranty</span><span>' + I.swatch + ' Free finish samples</span></div>' +
              '</div>' +
            '</div>' +
          '</aside>' +
        '</div>' +
        (tabsHtml ? '<section class="cfg__tabs"><div class="sec-head" style="margin-bottom:1.5rem"><div class="sec-head__t"><p class="eyebrow">The detail</p><h2 class="h-md">Everything about this vanity</h2></div></div><div class="acc" data-cfg-acc>' + tabsHtml + '</div></section>' : '') +
      '</div>';

    // the server-rendered rating row, if the product has a real one
    var ratingTpl = document.querySelector('template[data-cfg-rating]');
    var badges = root.querySelector('.cfg__badges');
    if (ratingTpl && badges) badges.appendChild(ratingTpl.content.cloneNode(true));

    $$('[data-cfg-acc] .acc__head').forEach(function (h) { h.addEventListener('click', function () { h.closest('.acc__item').classList.toggle('is-open'); }); });

    // ---- helpers ----
    function chosenName(id) { var s = opt(id), v = st[id]; if (s.type === 'addon-check') { return Array.from(st[id]).map(function (i) { return s.options[i].name; }).join(', '); } return (v != null && s.options[v]) ? s.options[v].name : null; }
    function selName(id) { var s = opt(id), v = st[id]; return (v != null && s.options[v]) ? s.options[v].name : null; }
    function selNum(id) { var s = opt(id), v = st[id]; if (v == null || !s.options[v]) return null; var o = s.options[v]; if (typeof o.num === 'number') return o.num; var m = String(o.name).match(/\d[\d,]*/); return m ? +m[0].replace(/,/g, '') : null; }

    // ---- declarative rule engine ----
    function condMet(c) {
      var op = c.op || 'in';
      if (op === 'in' || op === 'not_in') { var sel = selName(c.field); var inList = sel != null && c.values.indexOf(sel) !== -1; return op === 'in' ? inList : !inList; }
      var n = selNum(c.field); if (n == null) return false;
      switch (op) { case 'gt': return n > c.values[0]; case 'gte': return n >= c.values[0]; case 'lt': return n < c.values[0]; case 'lte': return n <= c.values[0]; case 'range': return n >= c.values[0] && n <= c.values[1]; default: return false; }
    }
    function condsMet(cn) { if (!cn) return true; if (cn.all && !cn.all.every(condMet)) return false; if (cn.any && !cn.any.some(condMet)) return false; return true; }
    function optAvailable(fieldId, i) {
      var nm = opt(fieldId).options[i].name, hasShow = false, showOk = false, rules = C.rules || [];
      for (var k = 0; k < rules.length; k++) {
        var r = rules[k]; if (!r.target || r.target.field !== fieldId) continue;
        if (r.target.option != null && r.target.option !== nm && r.target.option !== i) continue;
        var met = condsMet(r.conditions);
        if (r.effect === 'disable' || r.effect === 'hide') { if (met) return { ok: false, hide: r.effect === 'hide' }; }
        else if (r.effect === 'show') { hasShow = true; if (met) showOk = true; }
      }
      if (hasShow && !showOk) return { ok: false, hide: true };
      return { ok: true, hide: false };
    }
    function applyRules() {
      C.steps.forEach(function (s) {
        s.options.forEach(function (o, i) {
          var a = optAvailable(s.id, i), ok = a.ok;
          if (s.type === 'select' || s.type === 'addon-select') { var el = $('[data-cfgsel="' + s.id + '"] option[value="' + i + '"]'); if (el) { el.disabled = !ok; el.hidden = !ok; } }
          else if (s.type === 'addon-check') { var c = $('[data-cfgchk="' + s.id + '"][data-i="' + i + '"]'); if (c) { c.disabled = !ok; var w = c.closest('.cfg-check'); w.classList.toggle('is-disabled', !ok); w.hidden = a.hide; if (!ok && c.checked) { c.checked = false; st[s.id].delete(i); } } }
          else { var b = $('[data-cfg="' + s.id + '"][data-i="' + i + '"]'); if (b) { b.disabled = !ok; b.classList.toggle('is-disabled', !ok); b.hidden = a.hide; } }
        });
        if (s.type === 'addon-check') return;
        var v = st[s.id];
        if (v != null && s.options[v] && !optAvailable(s.id, v).ok) {
          if (s.type === 'addon-select') { st[s.id] = 0; var sel = $('[data-cfgsel="' + s.id + '"]'); if (sel) sel.value = '0'; }
          else if (s.type === 'select') { st[s.id] = null; var sel2 = $('[data-cfgsel="' + s.id + '"]'); if (sel2) sel2.value = ''; }
          else { st[s.id] = null; $$('[data-cfg="' + s.id + '"]').forEach(function (x) { x.classList.remove('is-on'); }); }
        }
      });
    }

    var baseStep = C.steps.find(function (s) { return s.type === 'variant'; });
    var requiredIds = C.steps.filter(function (s) { return s.required && s.type !== 'variant'; }).map(function (s) { return s.id; });

    function update() {
      applyRules(); applyRules(); // two passes resolve one-level cascades
      var base = baseStep.options[st[baseStep.id]].price;
      // total = base + every selected option's price, walked generically off the
      // config (step ids are config-specific — hardcoding demo ids here once made
      // real configs' add-ons free on the label while the cart still charged them)
      var total = base;
      C.steps.forEach(function (s) {
        if (s.type === 'variant') return;
        if (s.type === 'addon-check') { st[s.id].forEach(function (i) { total += (s.options[i].price || 0); }); return; }
        var v = st[s.id];
        if (v != null && s.options[v]) total += (s.options[v].price || 0);
      });
      var missing = requiredIds.filter(function (id) { return st[id] == null; });
      C.steps.forEach(function (s) { var el = $('[data-chosen="' + s.id + '"]'); var nm = chosenName(s.id); el.textContent = nm || ''; el.classList.toggle('is-set', !!nm); });
      var rows = [['Base', baseStep.options[st[baseStep.id]].name, base]];
      C.steps.forEach(function (s) {
        if (s.type === 'variant') return;
        if (s.type === 'addon-check') { Array.from(st[s.id]).forEach(function (i) { rows.push([s.label, s.options[i].name, s.options[i].price]); }); return; }
        var v = st[s.id]; if (v == null) return;
        if ((s.type === 'addon-select' || s.type === 'addon-radio') && !v) return; // index 0 = "none"
        rows.push([s.label, s.options[v].name, (s.options[v].price || 0)]);
      });
      // per-line price: base shows its price, priced add-ons show "+$X",
      // no-charge choices (finishes etc.) keep the em-dash
      $('[data-cfg-sum]').innerHTML = rows.map(function (r, ri) { return '<li><span>' + esc(r[0]) + ': ' + esc(r[1]) + '</span><b>' + (r[2] ? (ri ? '+' : '') + MONEY(r[2]) : '—') + '</b></li>'; }).join('');
      $('[data-cfg-total]').textContent = MONEY(total);
      // strike-through RRP: the rrpFactor markup applies to the BASE VARIANT
      // ONLY — add-ons pass through at face value (never multiply them), and
      // the strike is dropped entirely when it wouldn't exceed the payable total
      var rrp = Math.round(base * (C.rrpFactor || 1)) + (total - base);
      $('[data-cfg-rrp]').textContent = rrp > total ? MONEY(rrp) : '';
      var selN = $('[data-cfg-selname]'); if (selN) selN.textContent = baseStep.options[st[baseStep.id]].name;
      var pv = $('[data-cfg-img]'), bimg = baseStep.options[st[baseStep.id]].img; if (pv && bimg && pv.getAttribute('src') !== bimg) pv.src = bimg;
      var add = $('[data-cfg-add]'), hint = $('[data-cfg-hint]');
      if (missing.length) { add.classList.add('is-blocked'); add.setAttribute('aria-disabled', 'true'); add.textContent = 'Select required options'; hint.textContent = 'Still to choose: ' + missing.map(function (m) { return opt(m).label; }).join(', '); }
      else { add.classList.remove('is-blocked'); add.removeAttribute('aria-disabled'); add.textContent = 'Add to cart — ' + MONEY(total); hint.textContent = ''; }
      // point-of-failure validation: clear error marks on steps once satisfied
      requiredIds.forEach(function (id) {
        if (st[id] == null) return;
        var sec = document.getElementById('cfgstep-' + id);
        if (sec && sec.classList.contains('cfg-step--error')) {
          sec.classList.remove('cfg-step--error');
          var msg = sec.querySelector('.cfg-step__error');
          if (msg) msg.remove();
        }
      });
      st._total = total;
    }

    // ---- wiring ----
    $$('[data-cfg]').forEach(function (b) { b.addEventListener('click', function () { var id = b.dataset.cfg, i = +b.dataset.i; st[id] = i; $$('[data-cfg="' + id + '"]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); update(); }); });
    $$('[data-cfgsel]').forEach(function (s) { s.addEventListener('change', function () { var id = s.dataset.cfgsel; st[id] = s.value === '' ? null : +s.value; update(); }); });
    $$('[data-cfgchk]').forEach(function (c) { c.addEventListener('change', function () { var id = c.dataset.cfgchk, i = +c.dataset.i; c.checked ? st[id].add(i) : st[id].delete(i); update(); }); });
    var def = $('[data-cfg="' + baseStep.id + '"][data-i="0"]'); if (def) def.classList.add('is-on');

    // ---- add to cart (bundle) ----
    function buildId() { var s = JSON.stringify(snapshot()), h = 0; for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; } return 'b' + (h >>> 0).toString(36); }
    function snapshot() { var o = {}; C.steps.forEach(function (s) { o[s.id] = s.type === 'addon-check' ? Array.from(st[s.id]).map(function (i) { return s.options[i].name; }) : chosenName(s.id); }); return o; }
    function lineProps() {
      var p = {};
      C.steps.forEach(function (s) { if (s.type === 'swatch' || s.type === 'radio' || s.type === 'select') { var nm = chosenName(s.id); if (nm) p[s.label] = nm; } });
      p._build_id = buildId(); p._config_json = JSON.stringify(snapshot());
      return p;
    }
    function cartItems() {
      var items = [], bid;
      var baseSel = baseStep.options[st[baseStep.id]];
      var props = lineProps(); bid = props._build_id;
      if (!baseSel || !baseSel.variantId) return null; // demo / unmapped
      items.push({ id: baseSel.variantId, quantity: 1, properties: props });
      C.steps.forEach(function (s) {
        if (s.type === 'addon-select' || s.type === 'addon-radio') { var o = s.options[st[s.id]]; if (o && o.variantId && (o.price || 0) > 0) items.push({ id: o.variantId, quantity: 1, properties: { _bundle: bid } }); }
        else if (s.type === 'addon-check') { Array.from(st[s.id]).forEach(function (i) { var o = s.options[i]; if (o && o.variantId) items.push({ id: o.variantId, quantity: 1, properties: { _bundle: bid } }); }); }
      });
      return items;
    }
    function toast(msg) { var t = document.querySelector('[data-cfg-toast]'); if (!t) return; t.textContent = msg; t.classList.add('is-on'); setTimeout(function () { t.classList.remove('is-on'); }, 3200); }

    $('[data-cfg-add]').addEventListener('click', function () {
      // A-2 point-of-failure pattern: attempting to add with required steps
      // unset marks each offending step inline and scrolls to the first
      var missingNow = requiredIds.filter(function (id) { return st[id] == null; });
      if (missingNow.length) {
        missingNow.forEach(function (id) {
          var sec = document.getElementById('cfgstep-' + id);
          if (!sec) return;
          sec.classList.add('cfg-step--error');
          if (!sec.querySelector('.cfg-step__error')) {
            var msg = document.createElement('p');
            msg.className = 'cfg-step__error';
            msg.textContent = 'This is a required field.';
            sec.querySelector('.cfg-step__head').appendChild(msg);
          }
        });
        var first = document.getElementById('cfgstep-' + missingNow[0]);
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var items = cartItems();
      if (!items) { toast('Demo configurator — connect product variants to enable checkout.'); return; }
      var api = window.SydneyTaps && window.SydneyTaps.cart;
      if (api) {
        // optimistic: the drawer opens with the bundle lines before
        // /cart/add.js answers; a 422 rolls them back with the message in the
        // drawer. Hints: config prices are dollars, the store wants cents.
        var baseOpt = baseStep.options[st[baseStep.id]];
        var h1 = document.querySelector('h1');
        items.forEach(function (it, i) {
          var opt = null;
          if (i === 0) opt = baseOpt;
          else C.steps.forEach(function (s) { (s.options || []).forEach(function (o) { if (o.variantId === it.id) opt = o; }); });
          it.hint = {
            product_title: i === 0 ? ((h1 && h1.textContent.trim()) || (opt && opt.name)) : (opt && opt.name),
            variant_title: i === 0 && opt ? opt.name : null,
            price: Math.round(((opt && opt.price) || 0) * 100),
            image: (opt && opt.img) || (baseOpt && baseOpt.img) || null,
            url: location.pathname,
          };
        });
        api.add(items, { open: true, confirm: true });
        return;
      }
      var btn = this; btn.setAttribute('aria-busy', 'true');
      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); return res.json(); })
        .then(function () { return refreshDrawer(); })
        .then(function () { openDrawer(); })
        .catch(function (e) { toast(e.message || 'Could not add to cart'); })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });

    function refreshDrawer() {
      if (!window.SectionRender) return Promise.resolve();
      var url = (window.cartUrl || (window.routes && window.routes.cart_url) || '/cart');
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'r=' + Date.now();
      return window.SectionRender.fetchSection(url, 'cart-drawer', { fresh: true }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var next = tmp.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
        if (next && cur) cur.replaceWith(next);
        var cnt = next ? (next.querySelector('.cart-drawer__count') || {}).textContent || '' : '';
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cnt; });
      }).catch(function () {});
    }
    function openDrawer() { var d = document.querySelector('#CartDrawer'); if (d) { d.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); } }

    update();
  }
})();
